export default "__VITE_ASSET__5UIcf0ve__"